interface ContentProps {
  children?: any;
}

function Content({ children }: ContentProps) {
  return <div className="mt-4 sm:m-4 h-full">{children}</div>;
}

export default Content;
